const navCols = [
  {
    title: "补档分区",
    links: [
      { label: "1970年代 水墨之源", href: "#era" },
      { label: "1980年代 国漫黄金", href: "#era" },
      { label: "1990年代 引进潮", href: "#era" },
      { label: "2000年代 纸媒尾声", href: "#era" },
    ],
  },
  {
    title: "内容精选",
    links: [
      { label: "经典老番补档", href: "#classics" },
      { label: "绝版考古精选", href: "#rare" },
      { label: "读者口碑", href: "#story" },
      { label: "常见问题", href: "#faq" },
    ],
  },
  {
    title: "关于与投稿",
    links: [
      { label: "关于本站", href: "#about" },
      { label: "投稿补档", href: "#contribute" },
      { label: "联系邮箱", href: "mailto:contact@073comics.example.com" },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-foreground-950 text-background-100">
      <div className="mx-auto max-w-7xl px-4 py-14 md:px-6 md:py-16">
        <div className="grid gap-10 lg:grid-cols-[1.4fr_1fr_1fr_1fr]">
          <div>
            <a href="#home" className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-lg font-bold text-background-50">
                07
              </span>
              <span className="font-heading text-xl text-background-50">
                073<span className="text-primary-400">漫画网</span>
              </span>
            </a>
            <p className="mt-4 max-w-xs text-sm leading-relaxed text-background-100/70">
              老漫画补档、童年漫画考古、经典老番与绝版资源归档站。按年代翻找，点开就能找回当年那部。
            </p>
            <div className="mt-5 flex gap-3">
              {["ri-weibo-line", "ri-bilibili-line", "ri-mail-line"].map((icon, i) => (
                <a
                  key={i}
                  href={icon === "ri-mail-line" ? "mailto:contact@073comics.example.com" : "#story"}
                  aria-label="社区入口"
                  className="flex h-10 w-10 items-center justify-center rounded-md bg-background-50/10 text-lg text-background-100 transition-colors hover:bg-primary-500 hover:text-background-50"
                >
                  <i className={icon}></i>
                </a>
              ))}
            </div>
          </div>

          {navCols.map((col) => (
            <nav key={col.title} aria-label={col.title}>
              <h3 className="font-heading text-base text-background-50">{col.title}</h3>
              <ul className="mt-4 space-y-2.5">
                {col.links.map((l) => (
                  <li key={l.label}>
                    <a
                      href={l.href}
                      className="text-sm whitespace-nowrap text-background-100/70 transition-colors hover:text-primary-300"
                    >
                      {l.label}
                    </a>
                  </li>
                ))}
              </ul>
            </nav>
          ))}
        </div>

        <div className="mt-12 flex flex-col items-start gap-3 border-t border-background-50/10 pt-6 sm:flex-row sm:items-center sm:justify-between">
          <p className="text-xs text-background-100/60">
            © {new Date().getFullYear()} 073漫画网 · 老漫画补档与童年漫画考古 · 保留所有权利
          </p>
          <p className="text-xs text-background-100/50">
            补档以资料保存与怀旧分享为初衷，尊重原作版权。
          </p>
        </div>
      </div>
    </footer>
  );
}